export default __webpack_public_path__ + "static/media/28.77b04b99.png";